import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import classnames from 'classnames';
import { Icon } from '../Icon';
import { Text } from '../Typography';
import { SortableItem, SortableHandle } from '~/native-ui/sortable/Sortable';

import { Menu } from "native-base";
import { HStack, themeTools } from "~/native-ui/native-base";


const factory = () => {
  class MenuItem extends Component {
    static itemName = "MENUITEM"
    static propTypes = {
      orderable: PropTypes.bool,
      caption: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      children: PropTypes.node,
      className: PropTypes.string,
      disabled: PropTypes.bool,
      checkable: PropTypes.bool,
      icon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
      ]),
      onClick: PropTypes.func,
      selected: PropTypes.bool,
      shortcut: PropTypes.string,
      theme: PropTypes.shape({
        caption: PropTypes.string,
        disabled: PropTypes.string,
        icon: PropTypes.string,
        menuItem: PropTypes.string,
        dragIcon: PropTypes.string,
        selected: PropTypes.string,
        shortcut: PropTypes.string,
      }),
    };

    static defaultProps = {
      className: '',
      disabled: false,
      selected: false,
      orderable: false,
    };

    handleClick = (event) => {
        if (this.props.disabled) { return; }
        this.props.onClick?.(event, this);
    };

    renderDragIcon() {
      if (!this.props.orderable) {
        return null;
      }

      return (
          <SortableHandle>
            <Icon type="drag-indicator" />
          </SortableHandle>
      )
    }

    renderItem() {
      let {
        caption,
        disabled,
        icon,
        iconFamily,
        selected,
        shortcut,
        theme = {},
        orderable,
        onClick,
        checkable,
        children = null,
        ...others
      } = this.props;


      const Component = checkable ? Menu.ItemOption : Menu.Item

      const menuItemProps = {
        ...others,
        flex: 1,
        isDisabled: disabled,
        onPress: this.handleClick,
        style: disabled ? { cursor: "initial" } : others.style,
        opacity: disabled ? 0.4 : 1,
        bg: disabled ? themeTools.mode("warmGray.200", 'warmGray.800')(this.props) : undefined,
      }

      return (
        <Component {...menuItemProps}>
            <HStack className="menu-item-wrap" space="2">
              { this.renderDragIcon() }
              { icon && typeof icon === "string" ? <Icon iconFamily={iconFamily} type={icon} /> : icon}
              { caption ? <Text className={theme.caption}>{caption}</Text> : null }
              { shortcut ? <Text fontSize="sm" className={theme.shortcut}>{shortcut}</Text> : null }
              { children }
            </HStack>
        </Component>
      );
    }

    render() {
      const item = this.renderItem();
      const { orderable, index } = this.props

      return !orderable
        ? item
        : (
          <SortableItem key={ index } index={ index }>
            { item }
          </SortableItem>
        );
    }
  }

  return MenuItem;
};

const MenuItem = factory();
export { factory as menuItemFactory };
export default MenuItem;
export { MenuItem };
